import * as React from 'react';
import { FunctionComponent } from 'react';
import './AdminSchoolsDeclineInvitesModal.scss';

interface Props {
  modalTitle: string;
  commentText: string;
  onCommentTextChange: (event) => void;
  onCloseClick: () => void;
  onSaveClick: () => void;
  isOpen: boolean;
}

export const AdminSchoolsDeclineInvitesModal: FunctionComponent<Props> = props => {
  if (!props.isOpen) {
    return null;
  }

  const isCancel = props.modalTitle.toLowerCase().indexOf('cancel') !== -1;
  const actionLabel = isCancel ? 'Cancel invite' : 'Decline invite';
  return (
    <div className="inviteActionModal" role="presentation" onMouseDown={props.onCloseClick}>
      <div
        className="inviteActionModal__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="invite-action-title"
        onMouseDown={event => event.stopPropagation()}
      >
        <div className="inviteActionModal__head">
          <div className="inviteActionModal__icon">!</div>
          <div>
            <h5 id="invite-action-title">{isCancel ? 'Cancel invite?' : 'Decline invite?'}</h5>
            <p>
              {isCancel
                ? 'The invitation will be cancelled and moved out of your active outbox.'
                : 'The invitation will be declined and moved to the archive.'}
            </p>
          </div>
          <button type="button" className="inviteActionModal__close" onClick={props.onCloseClick} aria-label="Close">
            <span>&times;</span>
          </button>
        </div>
        <div className="inviteActionModal__body">
          <div className="inviteActionModal__notice">
            {isCancel
              ? 'You can add a comment explaining why this invitation is being cancelled.'
              : 'You can add a comment explaining why this invitation is being declined.'}
          </div>
          <label className="inviteActionModal__field">
            <span>Comment (optional)</span>
            <textarea
              rows={4}
              placeholder="Add a comment if needed"
              onChange={props.onCommentTextChange}
              value={props.commentText}
              autoFocus={true}
            />
          </label>
        </div>
        <div className="inviteActionModal__foot">
          <button type="button" className="inviteActionModal__button" onClick={props.onCloseClick}>
            Back
          </button>
          <button
            type="button"
            className="inviteActionModal__button inviteActionModal__button--danger"
            onClick={props.onSaveClick}
          >
            {actionLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

AdminSchoolsDeclineInvitesModal.displayName = 'AdminSchoolsDeclineInvitesModal';
